import PropTypes from 'prop-types';

const searchStatsFormStatePropTypes = PropTypes.shape({
    what: PropTypes.string.isRequired,
    where: PropTypes.string.isRequired,
    from: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
    allPlaces: PropTypes.bool.isRequired,
});

export default searchStatsFormStatePropTypes;
